import React, { useEffect, useState, useContext } from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import HeaderComponent from "../../../../HeaderComponent";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import { Routes } from ".";
import { useParams } from "react-router-dom";

interface Punctuality {
  interval: string;
  qtd: number;
}
export const ChartBar = ({ data }: Routes) => {
  const { getSizesComponent, setFontSize, componentProperty, generateRedirectUrl } =
    useContext(DashboardContext);
  const [completeRequisition, setCompleteRequisition] = useState(false);
  const [heightChart, setHeightChart] = useState(380);
  const [widthChart, setWidthChart] = useState(300);
  const [dataChart, setDataChart] = useState<number[]>([]);
  const [max, setMax] = useState<string>("");
  const [min, setMin] = useState<string>("");
  const { mode } = useParams();

  useEffect(() => {
    setDataChart(data.eta.map((route: Punctuality) => route.qtd));
    if (
      parseInt(data.eta[1].interval.split("-")[0]) % 60 !== 0 &&
      parseInt(data.eta[1].interval.split("-")[0]) > 60
    ) {
      const hours = Math.floor(
        parseInt(data.eta[1].interval.split("-")[0]) / 60
      );
      const minutes = parseInt(data.eta[1].interval.split("-")[0]) % 60;
      setMin(hours + "h" + minutes + "m");
    } else if (parseInt(data.eta[1].interval.split("-")[0]) >= 60) {
      const hours = Math.floor(
        parseInt(data.eta[1].interval.split("-")[0]) / 60
      );
      setMin(hours + "h");
    } else {
      setMin(data.eta[1].interval.split("-")[0] + "m");
    }
    if (
      parseInt(data.eta[1].interval.split("-")[1]) % 60 !== 0 &&
      parseInt(data.eta[1].interval.split("-")[1]) > 60
    ) {
      const hours = Math.floor(
        parseInt(data.eta[1].interval.split("-")[1]) / 60
      );
      const minutes = parseInt(data.eta[1].interval.split("-")[1]) % 60;
      setMax(hours + "h" + minutes + "m");
    } else if (parseInt(data.eta[1].interval.split("-")[1]) >= 60) {
      const hours = Math.floor(
        parseInt(data.eta[1].interval.split("-")[1]) / 60
      );
      setMax(hours + "h");
    } else {
      setMax(data.eta[1].interval.split("-")[1] + "m");
    }
  }, [data]);

  useEffect(() => {
    const sizes = getSizesComponent({ id: "chart-punctual-general" });
    if (sizes.width < 345) {
      setFontSize({ id: "chart-punctual-general", width: sizes.width });
    }
    setHeightChart(sizes.height - 40);
    setWidthChart(sizes.width);
    setCompleteRequisition(true);
  }, [dataChart]);

  const labels = [
    "No horário",
    "Entre " + min + " e " + max + " de atraso",
    "Mais de " + max + " de atraso",
  ];

  const options: ApexOptions = {
    chart: {
      animations: {
        dynamicAnimation: {
          enabled: true,
          speed: 350,
        },
        enabled: false,
      },
      type: "bar",
      toolbar: {
        show: false,
      },
      events: {
        dataPointSelection: async (event, chartContext, config) => {
          let timediff = "";
          switch (labels[config.dataPointIndex]) {
            case "No horário":
              timediff = `ontime`;
              break;
            case `Entre ${min} e ${max} de atraso`:
              timediff = `delayed`;
              break;
            case `Mais de ${max} de atraso`:
              timediff = `superdelayed`;
              break;
          }
          if (
            mode === "view" &&
            componentProperty({
              id: "chartPunctualGeneral",
              property: "redirect",
            })
          ) {
            window.open(
              await generateRedirectUrl("chartPunctualGeneral", {
                redirectTowerToRoutes: true,
                date: true,
                dueRouteDate: 'dateR',
                timediff: timediff,
                status_route_id_nin: '0,1,6,10',
                status_stop_id: '2,3,4,6,8,9,13,14'
              }),
              "_blank"
            );
          }
        },
      },
    },
    plotOptions: {
      bar: {
        barHeight: "80%",
        distributed: true,
        horizontal: true,
        dataLabels: { position: "bottom" },
      },
    },
    colors: ["#01b8aa", "#FFC125", "#fd6763"],
    dataLabels: {
      enabled: true,
      textAnchor: "start",
      formatter: function (val, opt) {
        return labels[opt.dataPointIndex] + ":  " + val;
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: { position: "bottom" },
        },
      },
    ],
    yaxis: {
      labels: {
        show: false,
      },
    },
    xaxis: {
      max: Math.max(...dataChart),
      range: 7,
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
    labels: labels,
    tooltip: { enabled: false },
    legend: { show: false },
  };
  const series = [
    {
      data: dataChart,
    },
  ];

  return completeRequisition ? (
    <div className="h100">
      <HeaderComponent
        title={`Geral: ${data.count} rotas em andamento`}
        clickable={componentProperty({
          id: "chartPunctualGeneral",
          property: "redirect",
        })}
        id="chart-punctual-general"
      />
      <div id={"fixedBox"}>
        <div id="chart">
          <Chart
            type="bar"
            options={options}
            series={series}
            height={heightChart}
            width={widthChart}
          />
        </div>
      </div>
    </div>
  ) : (
    <LoadingGraphics/>
  );
};
